import React from 'react';
import Component from 'components/nav/Nav';
import {connect} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {previous, next} from 'actions/NavActions';
import {setAuto} from 'actions/UiActions';
import {TIME_BEFORE_UI_FADES} from '../constants';
import {Work, Id} from 'types/Work';

const ConnectedNav = connect(
	(state: {
		works: {
			all: Work[],
			id: Id,
			work: Work,
		},
		ui: any
	}) => ({
		works: state.works.all,
		id: state.works.id,
		work: state.works.work,
		mouseSide: state.ui.mouseSide,
		auto: state.ui.auto,
		visibleOnPropsChange: true,
		delay: TIME_BEFORE_UI_FADES,
		tapData: state.ui.tapData
	}),
	(dispatch: any): any => ({
		next: () => {
			dispatch(next())
		},
		previous: () => {
			dispatch(previous());
		},
		toggleAuto: () => {
			dispatch(setAuto());
		}
	})
)(Component);

// Wrapper component that uses useLocation hook
const Container = (props: any) => {
	const location = useLocation();
	return React.createElement(ConnectedNav, {...props, pathname: location.pathname});
};

export default Container;
